<template>
  <div>
    <slot></slot>
    <Page :total="total" :current="current" v-if="isPage" class="QHPage" :page-size="pageSize" @on-change="pageNoChange" @on-page-size-change="pageSizeChange" />
  </div>
</template>

<script>
export default {
  name: "QHTable",
  props: {
    total: {
      type: Number,
      required: true,
    },
    current: {
      type: Number,
      default: 1,
    },
    pageSize: {
      type: Number,
      default: 25,
    },
    pageThis: {
      type: Object,
      required: true,
    },
    isPage: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    pageNoChange(e) {
        console.log(e);
      this.pageThis.searchMap.pageNo = e;
      this.pageThis.getList(true);
    },
    pageSizeChange(e) {
      this.pageThis.searchMap.pageSize = e;
      this.pageThis.getList(true);
    },
  },
};
</script>
